import { Card, CardContent } from "@/components/ui/card"

export function OrderCardSkeleton() {
  return (
    <Card className="overflow-hidden border rounded-xl py-0 shadow-sm animate-pulse">
      <CardContent className="p-0">
        <div className="px-4 pt-4 flex items-center justify-between">
          <div className="flex items-center gap-4">
            <div className="w-10 h-10 bg-gray-200 rounded-xl" />
            <div className="space-y-2">
              <div className="h-4 w-24 bg-gray-200 rounded" />
              <div className="h-3 w-16 bg-gray-200 rounded" />
            </div>
          </div>
          <div className="text-right space-y-2">
            <div className="h-4 w-12 bg-gray-200 rounded ml-auto" />
            <div className="h-4 w-16 bg-gray-200 rounded-full ml-auto" />
          </div>
        </div>
        <div className="px-4 py-2 mt-3 bg-gray-200 flex items-center gap-2">
          <div className="flex-1 h-8 bg-white border border-gray-100 rounded-sm" />
          <div className="flex-1 h-8 bg-white border border-gray-100 rounded-sm" />
        </div>
      </CardContent>
    </Card>
  )
}

export function OrderDetailSkeleton() {
  return (
    <div className="px-6 space-y-8 max-w-2xl mx-auto mt-6 animate-pulse">
      <div className="h-4 w-48 bg-gray-200 rounded mx-auto" />
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="p-4 bg-gray-200 rounded-2xl h-24" />
        <div className="p-4 bg-gray-200 rounded-2xl h-24" />
      </div>

      <div className="space-y-4">
        <div className="h-5 w-24 bg-gray-200 rounded" />
        <div className="space-y-3">
          {[1, 2].map((i) => (
            <div key={i} className="flex items-center gap-4 p-3.5 bg-white rounded-3xl shadow-sm border border-gray-50 h-20" />
          ))}
        </div>
      </div>

      <div className="p-5 bg-gray-200 rounded-2xl h-32" />
    </div>
  )
}
